<template>
  <div class="product-quantity">
    <button type="button" class="product-quantity__button product-quantity__button--minus" @click="updateQuantity(cartRow.quantity - 1)"></button>

    <input
      ref="quantity"
      v-model.number="cartRow.quantity"
      :type="inputType"
      class="product-quantity__input"
      @keyup.enter="doUpdate"
      @blur="doUpdate"
      @input="emitQuantity(displayQuantity)"
      @focus="selectInputValue()">

    <button type="button" class="product-quantity__button product-quantity__button--plus" @click="updateQuantity(cartRow.quantity + 1)"></button>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    cartRow: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      update: _.debounce(this.doUpdate, 800),
      desiredQuantity: 0,
      maxValue: this.cartRow.quantity
    }
  },
  computed: {
    inputType() {
      return this.mq('medium') ? 'input' : 'number'
    }
  },
  methods: {
    doUpdate() {
      this.currentQuantity = this.cartRow.quantity

      if (this.cartRow.quantity < 1) {
        this.cartRow.quantity = 0
      } else if (this.cartRow.quantity > this.maxValue) {
        this.cartRow.quantity = this.maxValue
      }

      this.publish('order-return-product-quantity-updated', this.cartRow)

      this.cartRow.isVisible = true
    },
    updateQuantity(desiredQuantity) {
      if (desiredQuantity >= 1 && desiredQuantity <= this.maxValue) {
        this.cartRow.quantity = desiredQuantity
      }

      this.update()
      this.emitQuantity(this.cartRow.quantity)
    },
    emitQuantity(quantity) {
      if (quantity >= 1 && quantity <= this.maxValue) {
        this.$emit('input', quantity)
      }
    },
    selectInputValue() {
      this.$refs.quantity.setSelectionRange(0, this.$refs.quantity.value.length)
    }
  }
}
</script>

<style lang="scss">
  .product-quantity {
    display: flex;
    align-items: center;
    width: auto;
    padding: measure(eighth) measure(quarter);
    background-color: color(background-blue-5);
  }

  .product-quantity--border {
    display: none;

    @include media(small) {
      display: flex;
      height: 3.125rem;
      border: 2px solid color(border-blue-4);
    }
  }

  .product-quantity__button {
    @include reset-button;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0.9375rem;
    height: 0.9375rem;
    background-repeat: no-repeat;
    background-position: center;

    &:hover {
      cursor: pointer;
    }
  }

  .product-quantity--border .product-quantity__input {
    height: 100%;
  }

  .product-quantity__button--minus {
    @include background-svg(circleMinus);
  }

  .product-quantity__button--plus {
    @include background-svg(circlePlus);
  }

  .product-quantity__input {
    @include caption-semi-bold;
    width: 1.875rem;
    height: 1.875rem;
    margin: 0 measure(quarter);
    text-align: center;
    background-color: color(background-white);
    border: none;
  }
</style>
